<template>
  <div class="home">
    <div class="container">
      <ul class="nav nav-tabs mBottom">
        <li class="nav-item navHeader">
          <a
            class="nav-link"
            :class="{ active: disabled}"
            @click="activateList"
          >Bestellliste</a>
        </li>
        <li class="nav-item navHeader">
          <a
            class="nav-link"
            :class="{ active: !disabled }"
            @click="activateSearch"
          >Objekt-Suche</a>
        </li>
        <li>
          <button
            class="logout-btn btn btn-danger"
            @click="logout"
          >
            Logout
          </button>
        </li>
      </ul>
      <div class="container-fluid">
        <OrderList v-if="disabled"></OrderList>
        <PropertySearch v-if="!disabled"></PropertySearch>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from '../components/OrderList.vue'
import PropertySearch from '../components/PropertySearch.vue'

export default {
  name: 'Home',
  components: {
    OrderList,
    PropertySearch
  },
  data () {
    return {
      disabled: Boolean
    }
  },
  mounted () {
    const exp = new Date(localStorage.getItem('exp'))
    const now = new Date()

    if (exp - now < 0) {
      this.logout()
    }

    var dis = localStorage.getItem('dis')
    this.disabled = dis
  },
  methods: {
    logout () {
      localStorage.removeItem('id')
      localStorage.removeItem('token')
      localStorage.removeItem('exp')
      localStorage.removeItem('order_id')
      localStorage.removeItem('prop_id')
      this.$router.push('/')
    },
    activateList () {
      localStorage.setItem('dis', true)
      this.disabled = true
    },
    activateSearch () {
      localStorage.setItem('dis', false)
      this.disabled = false
    }
  }
}
</script>
<style>
</style>
